import { locationIdFormat } from "@redotech/redo-inventory-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

const ReplenishmentPlanProductSchema = z.object({
  productId: z.string(),
  title: z.string(),
  shortTitle: z.string(),
  familyTitle: z.string().nullable(),
  sku: z.string().nullable(),
  imageUrl: z.string().nullable(),
  suggestedBin: z
    .object({
      storageLocationId: storageLocationIdFormat.schema,
      name: z.string(),
      type: z.string().nullable(),
    })
    .nullable(),
  quantityPerRun: z.number(),
});

const ReplenishmentPlanWorkOrderSchema = z.object({
  id: z.string(),
  status: z.enum(["not_started", "in_progress"]),
  runs: z.number(),
});

const ReplenishmentPlanWhySchema = z.object({
  unpickedDemand: z.number(),
  downstreamDemand: z.number(),
  onHand: z.number(),
  inProgressSupply: z.number(),
  shortfall: z.number(),
  hasReportDocument: z.boolean(),
  feeds: z.array(z.object({ bomId: z.string(), outputTitle: z.string() })),
});

const ReplenishmentPlanEntrySchema = z.object({
  bomId: z.string(),
  bomName: z.string(),
  stepName: z.string(),
  familyTitle: z.string().nullable(),
  groupOption: z.object({ name: z.string(), value: z.string() }).nullable(),
  source: ReplenishmentPlanProductSchema.nullable(),
  output: ReplenishmentPlanProductSchema,
  runs: z.number(),
  outputUnits: z.number(),
  leaves: z.number().nullable(),
  why: ReplenishmentPlanWhySchema,
  workOrders: z.array(ReplenishmentPlanWorkOrderSchema),
});

export type ReplenishmentPlanEntry = z.infer<
  typeof ReplenishmentPlanEntrySchema
>;

export const getReplenishmentPlan = {
  name: "getReplenishmentPlan" as const,
  input: z.object({ locationId: locationIdFormat.schema.optional() }),
  output: z.object({
    locationId: locationIdFormat.schema,
    entries: z.array(ReplenishmentPlanEntrySchema),
  }),
};
